import React from 'react';

const Input = ({ label, name, type = 'text', required = true, pattern, onFieldChange }) => {
  const className = `field field--${type} field--${name}`;

  return (
    <div className={className}>
      <label htmlFor={name} className="sr-only">
        {label}
      </label>
      <input
        id={name}
        name={name}
        type={type}
        placeholder={label}
        className="field__input"
        pattern={pattern}
        required={required}
        onInput={e => onFieldChange(e.target, e.target.value)}
      />
    </div>
  );
};

export default Input;
